import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo, useEffect, useMemo } from 'react';
import { __MUNICIPALITY_API_URL__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-old-http-fetch';
import { HttpResponse } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';
import { Territory } from 'shell/models/territory';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { PmiSelect } from 'shell/components/shared/pmi-select';

interface ConsulateListComponentProps {
  disabled?: boolean;
  value: string;
  onChange: (event: SelectChangeEvent<string>, value?: string) => void;
  error?: boolean;
  codeTerritory?: number | string;
}

const ConsulateListComponent = ({
  disabled,
  onChange,
  value,
  error,
  codeTerritory,
}: ConsulateListComponentProps): React.ReactElement => {
  const {
    data,
    error: errorlist,
    get: getConsulateListComponent,
  } = useHttpFetch<HttpResponse<Territory>>(`${__MUNICIPALITY_API_URL__}/geo/territorio`, {
    data: {
      payload: {
        list: [],
      },
    },
  });

  const list: Array<ItemVM> = useMemo(() => {
    if (!!errorlist || !data?.payload || !data?.payload?.consolati) {
      return [];
    }
    return data?.payload?.consolati?.map((item) => ({
      id: item.key?.codice,
      value: `${item.key?.codice} - ${item.nome} - ${item.comune.nome}`,
    }));
  }, [data, errorlist]);

  useEffect(() => {
    if (codeTerritory) {
      getConsulateListComponent(codeTerritory.toString());
    }
  }, [codeTerritory]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel error={error} disabled={disabled || !codeTerritory} id="consulate-label">
        Consolato
      </InputLabel>
      <PmiSelect
        labelId="consulate-label"
        id="consulate"
        name="consulate"
        value={value}
        label="Consolato"
        onChange={(event) =>
          onChange(event, list?.find((el) => el.id === event.target.value)?.value)
        }
        disabled={disabled || !codeTerritory}
        error={error}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((item: ItemVM) => (
          <MenuItem key={item.id} value={item.id}>
            {item.value}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

ConsulateListComponent.displayName = 'Consulate item component';

const ConsulateList = memo(ConsulateListComponent);

export default ConsulateList as typeof ConsulateListComponent;
